import { render, staticRenderFns } from "./ShortTestimonial.vue?vue&type=template&id=3085ebcb&scoped=true"
import script from "./ShortTestimonial.vue?vue&type=script&lang=js"
export * from "./ShortTestimonial.vue?vue&type=script&lang=js"
import style0 from "./ShortTestimonial.vue?vue&type=style&index=0&id=3085ebcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3085ebcb",
  null
  
)

export default component.exports